// src\pages\Collision\CollisionPage.tsx

export const CollisionPage = () => {
    return (
        <div>CollisionPage</div>
    )
}

export default CollisionPage